

















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { scale } from '@/utils/math';
import { throttle } from 'lodash';
import { NavMenuLink } from 'portfolio';
import SmoothScrolling from '@/utils/SmoothScrolling';

@Component
export default class NavMenu extends Vue {
  links: NavMenuLink[] = [
    {
      name: 'about',
      href: '/about',
      content: 'About',
      active: false,
      nodeId: 'about',
      node: undefined,
    },
    {
      name: 'work',
      href: '/work',
      content: 'Work',
      active: false,
      nodeId: 'work',
      node: undefined,
    },
    {
      name: 'contact',
      href: '/contact',
      content: 'Contact',
      active: false,
      nodeId: 'contact',
      node: undefined,
    },
  ]

  @Watch('$route')
  onRouteChanged(to: Route, from: Route) {
    const link = this.links.find(l => l.name === to.name);

    if (link) this.scrollToRoute(link);
  }

  mounted() {
    // Set current active route.
    this.links.forEach(l => l.active = this.$route.name === l.name);

    // Scroll to active route without animation if any.
    const activeRoute = this.links.find(l => l.active === true);
    if (activeRoute) SmoothScrolling.scrollTo(activeRoute.nodeId, false);

    // Handle page scroll.
    SmoothScrolling.ee.on('scroll', this.handlePageScroll);
  }

  private scrollToRoute(route: NavMenuLink) {
    SmoothScrolling.scrollTo(route.nodeId);
  }

  /**
   * Handle click on active route to scroll back to the associated content.
   */
  private handleClick(e: Event) {
    const node = e.target as HTMLElement;

    if (node.getAttribute('route-name') === this.$route.name) {
      const link = this.links.find(l => l.name === node.getAttribute('route-name'));
      if (link) this.scrollToRoute(link);
    }
  }

  /**
   * Handle page scroll to change active link.
   */
  private handlePageScroll(currentY: number) {
    let activeLink: NavMenuLink | undefined;

    this.links.forEach(link => {
      // Get content node if not already stored.
      if (!link.node) link.node = document.getElementById(link.nodeId) || undefined;

      // Is the content kinda positioned in a way that we can consider it "active"?
      // Note: Since each links are in the same order as the content on the page,
      //       from top to bottom, we know that the last content to validate the
      //       condition is the one we must consider "active".
      if (link.node && link.node.getBoundingClientRect().top < window.innerHeight / 10) activeLink = link;
    });

    this.links.forEach(link => link.active = activeLink && activeLink.name === link.name ? true : false);
  }
}
